<template>
  <div>
    <div class="form-base__title step-name">Опись документов</div>

    <AttachDocumentMultiple :documents="documents" disabled />
  </div>
</template>

<script>
import AttachDocumentMultiple from '@/components/base/AttachDocument/AttachDocumentMultiple';

export default {
  name: 'Documents',
  components: { AttachDocumentMultiple },
  props: {
    documents: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped></style>
